import { AXIOS } from "@/AXIOS/http-common";

const state = {
  listPeriods: [],
  listTreeUsers: [],
  usersByPeriodId: {},
};

const urlPrefix = "period-lock";

const actions = {
  async getListPeriods(context) {
    return await AXIOS.get(urlPrefix + "/list").then((response) => {
      console.log(response.data);
      context.commit("setListPeriods", response.data);
    });
  },
  async reEvalutPeriod(context, data) {
    return await AXIOS.get(urlPrefix + "/reEvalutPeriod?periodId=" + data);
  },
  async getTreeUsers(context) {
    return await AXIOS.get(urlPrefix + "/users/list").then((response) => {
      context.commit("setListUsers", response.data);
    });
  },
  async addNewPeriod(context, data) {
    return await AXIOS.post(urlPrefix + "/add", data);
  },
  async createNewPeriod(context, data) {
    return await AXIOS.post(
      urlPrefix + "/create?dateInfo=" + data.periodInfo.dateInfo,
      data
    );
  },
  async lockPeriod(context, data) {
    return await AXIOS.post(urlPrefix + "/lock", data);
  },
};

const mutations = {
  setListPeriods(state, data) {
    state.listPeriods = data;
  },
  setListUsers(state, data) {
    state.listTreeUsers = data;
  },
};

const getters = {
  GETLISTPERIODS: (state) => state.listPeriods,
  GETTREEUSERS: (state) => state.listTreeUsers,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
